import React from 'react'
import { Container, Row } from 'react-bootstrap';

const projectData = [
    /*{
        id: 1,
        title: "GSECL 33/440KV Substation RE Park Khavda",
        period: "2024 - 2025",
        work: "Sub Station Civil Work",
        client: "Amara Raja"
    },
    {
        id: 2,
        title: "GIPCL 600MW Solar PV Project",
        period: "2024 - 2025",
        work: "Main Control Room / ICR / Tracker Pilling",
        client: "Sterling And Wilson"
    },
    {
        id: 3,
        title: "GIPCL 600MW Solar PV Project",
        period: "2024 - 2025",
        work: "Tracker Installation / AC/DC (MMS Module)",
        client: "Sterling And Wilson Renewable Energy Ltd"
    },
    {
        id: 4,
        title: "GSECL 33/400KV 1361MV North Block Pooling Sub Station",
        period: "2024 - 2025",
        work: "TMR Pilling Work / Sub Station Civil Foundation",
        client: "Kintech Synergy Pvt Ltd",
        website: "https://www.kintechsynergy.com"
    },
    {
        id: 5,
        title: "JSW 33MW AC Solar Ground Mounted Project RE Park Khavda",
        period: "2024 - 2025",
        work: "Main Control Room / ICR / Pile Foundation",
        client: "Gensol Engineering Ltd"
    },
    {
        id: 6,
        title: "NTPC 795MW Solar PV Project At RE Park Khavda",
        period: "2025",
        work: "Internal Road Work",
        client: "L&T"
    },
    {
        id: 7,
        title: "NHPC 200MW Grid Connected Solar PV Project At GSECL RE Park Khavda",
        period: "2025",
        work: "Internal Road Work",
        client: "Dineshchandra R. Agrawal Infracon Pvt. Ltd."
    },
    {
        id: 8,
        title: "GSECL 33/440KV Substation RE Park Khavda",
        period: "2025",
        work: "33/440KV Transmission Line Pilling And Foundation",
        client: "Amara Raja"
    }*/
    {
        id: 1,
        title: "ADANI RENEWABLES 475MW , KHAVDA HYBRID POWER PROJECT, KUTCH GUJARAT",
        period: "2025",
        work: "200 MW EPC / Tracker Pilling / ICR Super Structure / AcDc / RMC Supply",
        client: "Amara Raja Infra PVT. LTD."
    },
    {
        id: 2,
        title: "NHPC 200MW Grid Connected Solar PV Project At GSECL RE Park Khavda",
        period: "2025",
        work: "200 MW EPC / Tracker Pilling / ICR Super Structure / AcDc / RMC Supply",
        client: "SOLAR WORLD ENERGY SOLUTIONS LTD"
    },
    {
        id: 3,
        title: "NHPC 200MW Grid Connected Solar PV Project At GSECL RE Park Khavda",
        period: "2025",
        work: "Road Word",
        client: "SOLAR WORLD ENERGY SOLUTIONS LTD"
    },
    {
        id: 4,
        title: "300MW_(SECI) BHUJ-POOL-II , SOLAR PV PROJECT AT GUJARAT .",
        period: "2025",
        work: "Main Control Room / 33KV HT PANEL ROOM 1&2",
        client: "AVAADA CLEAN PROJECT PVT. LTD."
    },
    {
        id: 5,
        title: "GIPCL 600MW Solar PV Project",
        period: "2025",
        work: "50mw EPC Basis / Invetor Control Room / Tracker Pilling / AC/DC",
        client: "Sterling And Wilson Renewable Energy Ltd"
    },
    {
        id: 6,
        title: "NTPC 795MW Solar PV Project At RE Park Khavda",
        period: "2025",
        work: "Internal Road Work",
        client: "L&T"
    },
];



export default function OnGoingProjects() {
    return (
        <Container className="mission pt-5 pb-5" >
            <div className="text-center">
                <h2 className='center'><span>Ongoing</span> Projects  </h2><br />
                {/* <p>What makes us the best choice</p> */}
            </div>
            <Row className='d-flex justify-content-center pt-5'>
                {/* {projectData.map((item) => {
                    return <Col md={3} className="mission-row pt-3" key={item.id}>
                        <div className="card-mission-1">
                            <h3 className='text-start'>{item.title}</h3>
                            <p><span className='fw-bold'>Period : </span>{item.period}</p>
                            <p><span className='fw-bold'>Work : </span>{item.work}</p>
                            <p><span className='fw-bold'>Client : </span>{item.client}</p>
                        </div>
                    </Col>}
                )} */}
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped spec-table">
                        <thead className="table-secondary">
                            <tr>
                            <th className="text-center">No.</th>
                                <th className="text-center">Title</th>
                                <th className="text-center">Period</th>
                                <th className="text-center">Work</th>
                                <th className="text-center">Client</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectData.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}.</td>
                                    <td>{item.title}</td>
                                    <td>{item.period}</td>
                                    <td>{item.work}</td>
                                    <td>{item.client}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </Row>
        </Container >
    )
}
